import styled from 'styled-components';

import { applyColorFromProps } from 'packages/kakapo-ui-kit/helpers/Theme';
import Breakpoint from 'packages/kakapo-ui-kit/helpers/Breakpoint';

interface IProps {
	color?: string;
	customBackgroundColor?: string;
	size?: number;
}

export default styled.p<IProps>`
	width: ${(props) => `${props.size ?? 32}px`};
	height: ${(props) => `${props.size ?? 32}px`};
	border-radius: ${(props) => `${Math.round((props.size ?? 32) / 2)}px`};
	font-size: 15px;
	color: ${(props) => props.theme.colors.white};
	background-color: ${(props) =>
		props.customBackgroundColor ?? applyColorFromProps(props, 'primary')};
	font-weight: 700;
	display: flex;
	justify-content: center;
	align-items: center;

	@media screen and (max-width: ${Breakpoint.Medium}) {
		max-width: 80px;
		max-height: 80px;
	}
`;
